exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-login-PasswordResetPage-header{margin:25px 0 50px 0;color:#ad1f2c}.src-components-login-PasswordResetPage-logo{margin-top:50px;width:300px}", ""]);

// exports
exports.locals = {
	"header": "src-components-login-PasswordResetPage-header",
	"logo": "src-components-login-PasswordResetPage-logo"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/login/PasswordResetPage/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/login/PasswordResetPage/styles.scss
// module chunks = 1